module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-chunk-01@2x.377dd88f.jpg";